/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (inpaint effect) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export default {
	type: 'object',
	properties: {
		blend: {
			type: 'number',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 0,
			label: 'Blend',
			unit: '%',
			kind: 'range',
			tooltip: {
				heading: 'Mask Blend',
				body: 'How strongly the mask is applied. At 0 the effect is off; at 100 everything outside the mask is exactly the original video.',
			},
		},
		sensitivity: {
			type: 'integer',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 0,
			label: 'Sensitivity',
			unit: '%',
			kind: 'range',
			tooltip: {
				heading: 'Mask Sensitivity',
				body: 'How certain the segmentation must be before a pixel joins the mask. Low keeps only what is clearly the subject; high also takes in what surrounds it.',
			},
		},
		offset: {
			type: 'integer',
			minimum: -20,
			maximum: 20,
			step: 1,
			initial: 0,
			label: 'Offset',
			kind: 'range',
			tooltip: {
				heading: 'Mask Offset',
				body: 'Expands or shrinks the mask region. Positive values grow the mask outward, negative values shrink it inward.',
			},
		},
		feather: {
			type: 'integer',
			minimum: 0,
			maximum: 20,
			step: 1,
			initial: 2,
			label: 'Feather',
			kind: 'range',
			tooltip: {
				heading: 'Mask Feather',
				body: 'Softens the edges of the inpaint mask, blending the inpainted region more smoothly with the surrounding area.',
			},
		},
		invert: {
			type: 'boolean',
			initial: false,
			label: 'Invert Mask',
		},
	},
	label: 'Personal',
	primary: ['blend'],
}
